SlideView = require("views/slide")
VimeoAPI  = require("lib/vimeo-api")

class VimeoVideoEmbedView extends SlideView
  template: require("./template")

  events:
    "iostap .btn-done": "submit"
    "iostap": "playVideo"

  serialize: ->
    data = super()

    data.continueBtnText = i18n("video.skip-video")
    data.videoId   = data?.videoId.toString().match(/\d+$/)?[0]
    data.thumbnail = @videoData?.thumbnail_large
    data.skipButton = if data?.showSkipButton? then data.showSkipButton else true

    data

  render: ->
    super()
    @createPlayer()

    onLoad = (e) =>
      @getEl("vimeo-thumb").removeEventListener "load", onLoad
      @getEl("vimeo-thumb").removeEventListener "error", onLoad
      @getEl("vimeo-thumb").classList.add("show")
      @setState("paused", "video")

    @setEl @findOne(".vimeo-thumb"), "vimeo-thumb"
    @getEl("vimeo-thumb").addEventListener "load", onLoad
    @getEl("vimeo-thumb").addEventListener "error", onLoad

  beforeShow: (lmsMode) ->
    @trigger("ui", lightbox: true, flexibleHeight: true)

    if lmsMode
      @options.data.autoplay = !lmsMode

  beforeHide: ->
    window.clearTimeout @ensureTimeout
    window.clearTimeout @autoplayTimeout

    @player?.pause?()
    @trigger("ui", lightbox: false, flexibleHeight: false)

  playVideo: ->
    if @player?
      @player.play()
    else
      @ensure (=> @player?.element?.contentWindow), => @playVideo()

  createPlayer: ->
    @ensure (-> window.Vimeo?.Player?), =>
      el = @findOne(".vimeo-player")

      return unless el

      @player = new Vimeo.Player el,
        id: @serialize().videoId
        width: el.offsetWidth
        height: el.offsetHeight
        title: false
        portrait: false
        byline: false
        color: "ffffff"
        autoplay: @options.data.autoplay
        playsinline: false
        allowfullscreen: true

      @player.on "ended",  => @onVideoEnded()
      @player.on "play",   => @setState("playing", "video")
      @player.on "pause",  => @setState("paused", "video")
      @player.on "loaded", => @setState("paused", "video")

      @loadThumbnail =>
        if @options.data.autoplay and window.location.href.split("thumbnail=true").length isnt 2
          @autoplayTimeout = window.setTimeout (=> @playVideo()), 400

  onRefresh: ->
    window.clearTimeout @autoplayTimeout
    window.clearTimeout @ensureTimeout

    if @player?
      @player.loadVideo @serialize().videoId
    else
      @createPlayer()

    @setState("loading", "video")
    @getEl("vimeo-thumb").classList.remove("show")
    @beforeShow(true)

  submit: (e) ->
    @player.off("play ended pause loaded")
    @$(@player.element).remove()
    e?.stopImmediatePropagation()
    super()

  onVideoEnded: () ->
    autoProgress = if @options.data?.autoProgress? then @options.data.autoProgress else true

    if autoProgress
      @submit()
    else
      @setState("touched")
      @findOne(".btn-done").innerHTML = i18n("buttons.continue")


  ensure: (cond, done) ->
    do repeat = =>
      if cond()
        done()
      else
        @ensureTimeout = window.setTimeout(repeat, 100)

  loadThumbnail: (done) ->
    onError = =>
      @getEl("vimeo-thumb")?.src = "img/video/empty.png"
      @setState("false", "thumb")
      done()

    @request?.abort()
    @request = $.ajax
      type: "GET"
      url: "https://vimeo.com/api/v2/video/#{@serialize().videoId}.json"
      dataType: "json"
      error: onError
      success: ([ resp ] = []) =>
        if resp
          @videoData = resp
          @getEl("vimeo-thumb")?.src = resp.thumbnail_large
          done()
        else
          onError()

module.exports = VimeoVideoEmbedView
